module.exports = __webpack_public_path__ + "static/media/icon-menu-up-active.efe04025.svg";